import { Map } from 'immutable';

/**
 * Custom messages for Ticketyboo
 */

module.exports = new Map({
    'app.owner': 'TicketyBoo',
    'app.owner.short': 'TicketyBoo',
    'app.owner.appName': 'TicketyBoo',

    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.orders.refund.warning.manualRefund.contactUs': 'Frequently Asked Questions',

    'alertmessage.registration.failed.emailInUse': 'You already have an account with TicketyBoo. Please log in or use a different email address.',
    'alertmessage.paymentRegistration.failed.emailInUse': 'An account with the same email address already exists. Please log in or enter a different email address',

    'booking.delivery.loadingdate.download': 'Download the TicketyBoo app to load your ticket instantly',

    'booking.usp.noBookingFees.banner': 'No fees, No faff',
    'booking.usp.noBookingFees.inline': 'No fees, No faff',

    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the TicketyBoo app.',

    'ontrackapp.widget.title': 'The new TicketyBoo app is here',

    'refundWidget.field.surrenderDate': 'Date ticket surrendered',

    'preference-centre.promotions': 'TicketyBoo promotions, rewards and offers',

    'preference-centre.privacy-notice': 'We will not pass on your personal information to any organisation outside of <{app.owner.short}>.',

    'preference-centre.privacy-notice.more': '_',
    'preference-centre.privacy-notice.extra': '_',
});



// WEBPACK FOOTER //
// ./src/messages/ticketyboo.js